export const OFFLINE_PUNCH_RETRYABLE_STATUSES = new Set([
  'pending',
  'retrying',
]);

export const OFFLINE_PUNCH_ACTIVE_STATUSES = new Set([
  ...OFFLINE_PUNCH_RETRYABLE_STATUSES,
  'syncing',
  'permanent_failure',
]);
